import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'acompanhar_regua_cobranca', ptBr);
i18next.addResourceBundle('en', 'acompanhar_regua_cobranca', en);

const AcompanharReguaCobrancaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/acompanhar_regua_cobranca',
      component: React.lazy(() => import('./AcompanharReguaCobranca')),
    },
  ],
};

export default AcompanharReguaCobrancaConfig;
